<span>
  {{displayText}}
  <span class="destiny-symbol-text" *ngFor="let symbol of displayIcon">{{displayIcon}}</span>
</span>
